import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  owners_capital_account: yup
    .string()
    .required("Owners capital account mapping is required"),
  owners_drawing_account: yup
    .string()
    .required("Owners drawing account mapping is required"),
});

const Validation = ({ equityAccountMapping }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...equityAccountMapping,
    },
  });
};

export default Validation;
